import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';

const FILE_CONFIG = 'assets/configuration/config.json';

/**
 * Service is intended to configure the application.
 * Configuration is defined in config file
 */
@Injectable()
export class AppConfigService {
  private _configSubject: BehaviorSubject<any>;

  constructor(private _http: HttpClient) {
    this._configSubject = new BehaviorSubject<any>(undefined);
  }

  /**
   * Loads configuration file
   */
  load(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._http
        .get(`${FILE_CONFIG}`)
        .toPromise()
        .then((config) => {
          this._configSubject.next(config);
          resolve(true);
        })
        .catch((_) => {
          console.error(
            `OCC_ERROR: No configuration file found: ${FILE_CONFIG}`
          );
        });
    });
  }

  /**
   * Returns configuration of application as observable type
   */
  configuration(): Observable<any> {
    return this._configSubject.asObservable();
  }
}
